export enum ServiceTypeEnum {
  CORRECTIVE = "CORRECTIVE",
  PREVENTIVE = "PREVENTIVE",
  TIRES = "TIRES",
  GLASS = "GLASS"
}
